module.exports = __webpack_public_path__ + "img/ic_emoji_suprise.3d755a08.png";